<script>
	import { fade, fly } from 'svelte/transition';
</script>

<style>
	@import url('https://fonts.googleapis.com/css2?family=Newsreader:wght@300;400&display=swap');

	main {
		background-color: #e9c46a;
		font-family: 'Newsreader', serif;
	}

	.center {
		text-align: center;
		margin: 0 auto;
		max-width: 70%;
		padding-top: 7em;
	}

	.title {
		margin: 0;
		line-height: 0.6;
		color: #e76f51;
		font-size: 7em;
		font-weight: 300;
	}

	.subTitle {
		margin-top: 4em;
		font-size: 2em;
		font-weight: 300;
		color: #e76f51;
		line-height: 40px;
	}

	.description {
		margin-top: 1em;
		font-size: 2em;
		font-weight: 300;
		color: #e76f51;
		line-height: 40px;
	}

	.emphasis {
		font-weight: 400;
	}

	.bouncing {
		animation: bounce 0.4s, colorLoop 2s;
		animation-iteration-count: infinite;
		animation-direction: alternate;
	}

	span {
		display: inline-block;
	}

	.combinedLetter {
		display: block;
	}

	@media screen and (max-width: 800px) {
		.center {
			padding-top: 1em;
			max-width: 90%;
		}
		main {
			padding-bottom: 3em;
		}
		.subTitle {
			margin-top: 2em;
		}
	}


	@keyframes colorLoop {
		from {
			color: #e76f51;
		}
		to {
			color: #f4a261;
		}
	}

	@keyframes bounce {
		from {
			transform: translate3d(0, 0, 0);
		}

		to {
			transform: translate3d(0, -10px, 0);
		}
	}
</style>

<main>
	<div class="center">
		<div class="titleContainer" in:fly="{{y: 150, delay: 100,  duration: 800, intro: true}}">
			<p class="title">
				H<!--remove whitespace
			 --><span>
					<span class="combinedLetter bouncing">.</span>
					<span class="combinedLetter">ı</span>
				</span>
				there!
			</p>
		</div>

		<span class="subTitle" in:fade="{{delay: 600, duration:1000, intro: true}}">
			I'm
			<span class="emphasis">Sondre Widmark</span>,
			a full stack developer from Norway.
		</span>
		<span class="description" in:fade="{{delay: 1000, duration:1000, intro: true}}">
			There's nothing here at the moment, but things are in the works.
		</span>
	</div>
</main>
